module.exports = __webpack_public_path__ + "img/golf.7f7bb6a9.gif";